import { ColumnDef } from '@tanstack/react-table';
import AdvanceTable from 'components/base/AdvanceTable';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import AdvanceTableFooter from 'components/base/AdvanceTableFooter';
import Badge from 'components/base/Badge';
import { NumeroCelular } from 'data/crm/Personas';
import { formatCelular } from 'services/chatService'; // Asegúrate de tener esta función en utils/formatters


// Definimos las columnas estrictamente tipadas con NumeroCelular
const columns: ColumnDef<NumeroCelular>[] = [
  {
    accessorKey: 'celular',
    header: 'Número',
    cell: ({ row: { original } }) => (
      // 👈 Aplicamos la función formatCelular aquí
      <span className="fw-semibold text-primary">{formatCelular(original.celular)}</span>
    ),
    meta: {
      headerProps: { style: { width: '30%', minWidth: 150 } },
      cellProps: { className: 'py-2' }
    }
  },
  {
    accessorKey: 'descripcion',
    header: 'Descripción',
    cell: ({ row: { original } }) => original.descripcion,
    meta: {
      headerProps: { style: { width: '30%' } },
      cellProps: { className: 'text-body-tertiary' }
    }
  },
  {
    accessorKey: 'vigente',
    header: 'Vigente',
    cell: ({ row: { original } }) => (
      <Badge variant="phoenix" bg={original.vigente === 'YES' ? 'success' : 'secondary'}>
        {original.vigente === 'YES' ? 'Sí' : 'No'}
      </Badge>
    ),
    meta: {
      headerProps: { style: { width: '20%' }, className: 'text-center' },
      cellProps: { className: 'text-center' }
    }
  },
  {
    accessorKey: 'principal',
    header: 'Principal',
    cell: ({ row: { original } }) => (
      <Badge variant="phoenix" bg={original.principal === 'YES' ? 'info' : 'secondary'}>
        {original.principal === 'YES' ? 'Principal' : 'Secundario'}
      </Badge>
    ),
    meta: {
      headerProps: { style: { width: '20%' }, className: 'text-center' },
      cellProps: { className: 'text-center' }
    }
  }
];

interface TableProps {
  data: NumeroCelular[];
}

const PersonaCelularesTable = ({ data }: TableProps) => {
  const table = useAdvanceTable({
    data: data,
    columns,
    pageSize: 5,
    pagination: true,
    sortable: true,
    selection: false // Desactivado si no necesitas seleccionar filas
  });

  return (
    <div>
      <AdvanceTableProvider {...table}>
        <div className="border-y border-translucent">
          <AdvanceTable tableProps={{ className: 'phoenix-table fs-9' }} />
          {data.length > 0 ? (
             <AdvanceTableFooter pagination />
          ) : (
            <p className="p-3 text-center text-body-tertiary mb-0">No hay celulares registrados.</p>
          )}
        </div>
      </AdvanceTableProvider>
    </div>
  );
};

export default PersonaCelularesTable;